"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountTypes = exports.AccountTypeKeys = void 0;
var AccountTypeKeys;
(function (AccountTypeKeys) {
    AccountTypeKeys["ADMIN"] = "Admin";
    AccountTypeKeys["BUSINESS"] = "Business";
    AccountTypeKeys["COMMUNITY_CHAMPION"] = "Community_Champion";
    AccountTypeKeys["PREMIUM"] = "Premium";
    AccountTypeKeys["TRIAL"] = "Trial";
    AccountTypeKeys["INFLUENCER"] = "Influencer";
})(AccountTypeKeys = exports.AccountTypeKeys || (exports.AccountTypeKeys = {}));
/**
 * Account Types Module
 * Central source of data and commonly used functions for account types
 * These functions are used across client, server, and grapefruit.
 * One point of access to these functions ensures the account type data is protected
 */
const accountTypesObjectDetails = {
    [AccountTypeKeys.ADMIN]: {
        title: "Admin",
        badge: {
            color: "#808080",
        },
        priority: 1000,
    },
    [AccountTypeKeys.COMMUNITY_CHAMPION]: {
        title: "Superuser",
        badge: {
            color: "#9BB33F",
        },
        priority: 800,
    },
    [AccountTypeKeys.BUSINESS]: {
        title: "Business",
        badge: {
            color: "#4A88B3",
        },
        priority: 600,
    },
    [AccountTypeKeys.PREMIUM]: {
        title: "Full Throttle",
        badge: {
            color: "#C4A462",
        },
        priority: 400,
    },
    [AccountTypeKeys.TRIAL]: {
        title: "Full Throttle Trial",
        badge: {
            color: "#E8D3AA",
        },
        priority: 200,
    },
    [AccountTypeKeys.INFLUENCER]: {
        title: "Influencer",
        badge: {
            color: "#CA7731",
        },
        priority: 700,
    },
};
const populate = (accountTypes = []) => {
    return (accountTypes || [])
        .filter((a) => accountTypesObjectDetails[a])
        .map((a) => {
        return Object.assign({ key: a }, accountTypesObjectDetails[a]);
    })
        .filter((a) => a);
};
exports.AccountTypes = {
    /**
     * Compares two arrays of account types to see if they are equal
     * Two lists are considered equal if they have the same length, and each element from one is present in the other
     * ex. compare(["three", "two", "one"], ["two", "one", "three"]) is true
     * @param firstTypeArray Existing array of account type keyd
     * @param secondTypeArray Updated array of account type keys
     */
    compare: (firstTypeArray, secondTypeArray) => {
        return ((firstTypeArray || []).length === (secondTypeArray || []).length &&
            (firstTypeArray || []).every((eac) => (secondTypeArray || []).includes(eac)));
    },
    /**
     * Maps over an array of account type keys
     * Returns an array of account type data objects
     * @param accountTypes Array of account type keys
     */
    populate,
    /**
     * Finds the account type with the highest priority
     * Returns the priority number of the highest account type in that array
     * @param accountTypes Array of account type keys
     */
    max: (accountTypes) => {
        return populate(accountTypes || []).reduce((acc, cur) => {
            if (cur.priority > acc)
                acc = cur.priority;
            return acc;
        }, 0);
    },
    /**
     * Finds an account type key with the highest priority
     * Returns account type data for that key
     * @param accountTypes Array of account type keys
     */
    top: (accountTypes) => {
        if (!accountTypes)
            return null;
        const topAccountType = populate(accountTypes)
            .sort((a, b) => b.priority - a.priority)
            .shift();
        return topAccountType || null;
    },
};
